import style from "./Flex.module.css";
import clsx from "classnames";
import { cloneElement, Children } from "react";
import React from "react";

function FlexGrid(props) {
  const childrenWithProps = Children.map(props.children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, {
        parentClass: "grid",
        flexStart: props.flexStart ? props.flexStart : null,
      });
    }
    return child;
  });
  return (
    <div
      className={clsx(style.grid, props.className)}
      style={{
        width: props.width ? props.width : null,
        gap: props.gap ? props.gap : null,
        gridTemplateRows: props.rows
          ? `repeat(${props.rows}, ${props.gridGap ? props.gridGap : "1fr"})`
          : null,
        gridTemplateColumns: props.columns
          ? `repeat(${props.columns}, ${props.gridGap ? props.gridGap : "1fr"})`
          : null,
      }}
    >
      {childrenWithProps}
    </div>
  );
}

export default FlexGrid;
